import { TableColumn } from "react-data-table-component";
import { Button, FormGroup, Input } from "reactstrap";
import { ISettingType } from "src/services/types";

export const columnsSettingTypes: (
    onRequired: (item: ISettingType) => void,
    onActive: (item: ISettingType) => void,
    editRelevance: (item: ISettingType) => void
) => TableColumn<ISettingType>[] = 
(onRequired, onActive, editRelevance) => {
      
    return (
[
    {
      name: "CODE",
      width: "150px",
      center: true,
      selector: (row: ISettingType) => row.code,
    },
    {
      name: "NAME",
      width: "200px",
      selector: (row: ISettingType) => row.name,
    },
    {
      name: "RELEVANCE",
      width: "200px",
      center: true,
      // selector: (row: ISettingType) => row.globalRelevance,
      cell: function OrderItems(item) {
        return (
          <div>
            <span className="mx-2 fs-6">{item.globalRelevance}</span>
            <button
              type="button"
              className="btn btn-soft-primary btn-sm waves-effect waves-light rounded"
              onClick={()=>editRelevance(item)}
            >
              <i className="mdi mdi-lead-pencil"></i>
            </button>
            {/* <Button size="sm" color="primary" className="ml-2" >
              <i className="mdi mdi-lead-pencil"></i>
            </Button> */}
          </div>
            // <FormGroup switch>
            //     <Input
            //         type="switch"
            //         checked={item.isRequired}
            //         onChange={() => {onRequired(item)}}
            //     />
            // </FormGroup>
        );
      }
    },
    // {
    //   name: "IS REQUIRED",
    //   width: "150px",
    //   center: true,
    //   cell: function OrderItems(item) {
    //     return (
    //         <FormGroup switch>
    //             <Input
    //                 type="switch"
    //                 checked={item.isRequired}
    //                 onChange={() => {onRequired(item)}}
    //             />
    //         </FormGroup>
    //     );
    //   }
    // },
    {
      name: "ACTIVE",
      width: "150px",
      center: true,
      cell: function OrderItems(item) {
        return (
            <FormGroup switch>
                <Input
                    type="switch"
                    checked={item.active}
                    onChange={() => {onActive(item)}}
                />
            </FormGroup>
        );
      }
    },
  ]
)}